import type { ModalProps } from "@benchmark/ui/components/atomic";

/**
 * Near-full-viewport layout for encounter documentation modals (Complete Intake,
 * check-ins, Log Interaction, etc.). The overlay blocks the rest of the app, so
 * the modal uses most of the viewport for scrollable clinical content.
 * @agentic connections
 */
export const ENCOUNTER_DOCUMENTATION_MODAL_PROPS: Pick<
  ModalProps,
  "size" | "styles" | "centered"
> = {
  centered: true,
  size: "full",
  styles: {
    content: {
      width: "95vw",
      maxWidth: "95vw",
      height: "95vh",
      maxHeight: "95vh",
      display: "flex",
      flexDirection: "column",
    },
    body: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
    },
  },
};
